// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.6.1 (commit 052c83fe984a4c4eb7bb4f9afa5c6b1903891d87).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AbandonRunReducer from "./abandon_run_reducer";
import ContinueAfterResultReducer from "./continue_after_result_reducer";
import CreateRunReducer from "./create_run_reducer";
import RepairFractureReducer from "./repair_fracture_reducer";
import RosterBenchReducer from "./roster_bench_reducer";
import RosterEquipReducer from "./roster_equip_reducer";
import RosterMergeReducer from "./roster_merge_reducer";
import RosterPlaceReducer from "./roster_place_reducer";
import RosterSellChampionReducer from "./roster_sell_champion_reducer";
import RosterSellWeaponReducer from "./roster_sell_weapon_reducer";
import RosterUnequipReducer from "./roster_unequip_reducer";
import ShopBuyReducer from "./shop_buy_reducer";
import ShopChoosePathReducer from "./shop_choose_path_reducer";
import ShopConfirmReducer from "./shop_confirm_reducer";
import ShopLockReducer from "./shop_lock_reducer";
import ShopPickFocusReducer from "./shop_pick_focus_reducer";
import ShopRerollReducer from "./shop_reroll_reducer";
import ShopTakeBonusReducer from "./shop_take_bonus_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import BalanceConfigSnapshotRow from "./balance_config_snapshot_table";
import CombatLogRow from "./combat_log_table";
import PlayerRow from "./player_table";
import RunStateRow from "./run_state_table";
import SeatRow from "./seat_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  balanceConfigSnapshot: __table({
    name: 'balance_config_snapshot',
    indexes: [
      { accessor: 'seasonId', name: 'balance_config_snapshot_season_id_idx_btree', algorithm: 'btree', columns: [
        'seasonId',
      ] },
    ],
    constraints: [
      { name: 'balance_config_snapshot_season_id_key', constraint: 'unique', columns: ['seasonId'] },
    ],
  }, BalanceConfigSnapshotRow),
  combatLog: __table({
    name: 'combat_log',
    indexes: [
      { accessor: 'id', name: 'combat_log_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'combat_log_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CombatLogRow),
  player: __table({
    name: 'player',
    indexes: [
      { accessor: 'identity', name: 'player_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerRow),
  runState: __table({
    name: 'run_state',
    indexes: [
      { accessor: 'owner', name: 'run_state_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'run_state_owner_key', constraint: 'unique', columns: ['owner'] },
    ],
  }, RunStateRow),
  seat: __table({
    name: 'seat',
    indexes: [
      { accessor: 'id', name: 'seat_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'seat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, SeatRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("abandon_run", AbandonRunReducer),
  __reducerSchema("continue_after_result", ContinueAfterResultReducer),
  __reducerSchema("create_run", CreateRunReducer),
  __reducerSchema("repair_fracture", RepairFractureReducer),
  __reducerSchema("roster_bench", RosterBenchReducer),
  __reducerSchema("roster_equip", RosterEquipReducer),
  __reducerSchema("roster_merge", RosterMergeReducer),
  __reducerSchema("roster_place", RosterPlaceReducer),
  __reducerSchema("roster_sell_champion", RosterSellChampionReducer),
  __reducerSchema("roster_sell_weapon", RosterSellWeaponReducer),
  __reducerSchema("roster_unequip", RosterUnequipReducer),
  __reducerSchema("shop_buy", ShopBuyReducer),
  __reducerSchema("shop_choose_path", ShopChoosePathReducer),
  __reducerSchema("shop_confirm", ShopConfirmReducer),
  __reducerSchema("shop_lock", ShopLockReducer),
  __reducerSchema("shop_pick_focus", ShopPickFocusReducer),
  __reducerSchema("shop_reroll", ShopRerollReducer),
  __reducerSchema("shop_take_bonus", ShopTakeBonusReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.6.1" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

